import { createRoot } from 'react-dom/client'
import { store } from './store'
import { renderRoot } from './Root'

const root = createRoot(document.getElementById('root') as HTMLInputElement)

root.render(renderRoot(store))
